<template>
  <div class="logs-mobile-notice" data-testid="logs-mobile-notice">
    <div class="logs-mobile-notice__icon-circle">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <rect x="3" y="4" width="18" height="12" rx="2" />
        <line x1="8" y1="20" x2="16" y2="20" />
        <line x1="12" y1="16" x2="12" y2="20" />
      </svg>
    </div>
    <p class="logs-mobile-notice__title">Logs are desktop-only</p>
    <p class="logs-mobile-notice__subtitle">To view full log details, switch to desktop</p>
  </div>
</template>

<style scoped>
.logs-mobile-notice {
  @apply flex flex-col items-center justify-center text-center gap-3 p-8 rounded-10 border border-slate-200 dark:border-zinc-700 bg-white dark:bg-zinc-800;
}

.logs-mobile-notice__icon-circle {
  @apply flex items-center justify-center w-14 h-14 rounded-full bg-orange-100 dark:bg-orange-900/30 text-orange-500 dark:text-orange-400;
}

.logs-mobile-notice__title {
  @apply text-base font-bold text-zinc-900 dark:text-zinc-100;
}

.logs-mobile-notice__subtitle {
  @apply text-sm text-zinc-500 dark:text-zinc-400 max-w-xs;
}
</style>
